import { defineComponent as t, openBlock as r, createElementBlock as s, mergeProps as o, renderSlot as a } from "vue";
import "./ghl-ui.es224.js";
const l = t({
  name: "UITextXsRegular",
  inheritAttrs: !1
}), n = t({
  ...l,
  setup(c) {
    return (e, p) => (r(), s("div", o(e.$attrs, { class: "hl-text-xs-regular" }), [
      a(e.$slots, "default")
    ], 16));
  }
}), _ = n;
export {
  _ as default
};
